import { useMemo } from 'react';
import { BsCheckCircleFill, BsExclamationTriangleFill, BsFillXCircleFill } from 'react-icons/bs';
import { ClearanceStatusEnum } from '../../../api';

interface ClearanceBadgeProps {
  status: ClearanceStatusEnum;
  className?: string;
  size?: 'xs' | 'xl';
}

export const ClearanceBadge = ({ status, className, size = 'xs' }: ClearanceBadgeProps) => {
  const sizeStyle = useMemo(
    () => (size === 'xs' ? 'fs-12 py-2' : 'fs-16 px-3 py-2 line-height-normal'),
    [size]
  );

  const alignmentStyle = useMemo(() => (size === 'xl' ? 'align-middle' : 'align-bottom'), [size]);

  return (
    <>
      {status === ClearanceStatusEnum.CLEARED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-primary-muted text-primary-dark ${sizeStyle} ${
            className ?? ''
          }`}
          style={{ whiteSpace: 'nowrap' }}
        >
          <BsCheckCircleFill className={`me-1 ${alignmentStyle}`} />
          <span>Cleared</span>
        </div>
      )}

      {status === ClearanceStatusEnum.NOT_CLEARED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-red-100 ${sizeStyle} ${
            className ?? ''
          } d-inline-flex align-items-center`}
          style={{ whiteSpace: 'nowrap' }}
        >
          <BsFillXCircleFill className={`me-1 ${alignmentStyle}`} />
          <span>Not Cleared</span>
        </div>
      )}

      {status === ClearanceStatusEnum.PENDING_CLEARANCE && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal badge-warning-light ${sizeStyle} ${
            className ?? ''
          } d-inline-flex align-items-center`}
          style={{ whiteSpace: 'nowrap' }}
        >
          <BsExclamationTriangleFill className={`me-1 align-bottom text-warning-dark fs-14`} />
          <span>Pending Clearance</span>
        </div>
      )}
    </>
  );
};
